import React from "react"
import types from "prop-types"
import Modal, { ModalHeader } from "shared/Modal"
import EDIT_SUBMISSION_MODAL_STYLE from "./editSubmissionModalStyle"
import EditSubmissionOptionCard from "./EditSubmissionOptionCard"

const EditSubmissionModal = ({
  close, isOpen, onChangeAnswers, onChangeFormType,
}) => (
  <Modal isOpen={isOpen} style={EDIT_SUBMISSION_MODAL_STYLE}>
    <ModalHeader
      closeModal={close}
      heading="Edit Submission"
    />
    <p className="mb-8 text-sm text-center text-gray">
      How would you like to edit this submission?
    </p>
    <div className="flex flex-col sm:flex-row gap-4 justify-center">
      <EditSubmissionOptionCard
        description="Edit the answers on this submission."
        onClick={onChangeAnswers}
        title="Change Answers"
      />
      <EditSubmissionOptionCard
        description="Move this submission to a different form. Only answers to reporting fields are retained."
        onClick={onChangeFormType}
        title="Change Form Type"
      />
    </div>
  </Modal>
)

EditSubmissionModal.propTypes = {
  close: types.func.isRequired,
  isOpen: types.bool.isRequired,
  onChangeAnswers: types.func.isRequired,
  onChangeFormType: types.func.isRequired,
}

export default EditSubmissionModal
